<template>
    <card class="card">
        <div class="card-body">
            <h2 class="pt-0 mt-0">
                <i class="fas fa-user-cog text-primary"></i>{{$t('user.titleadd')}}
            </h2>
            <hr />
            <div>
                <form @submit.prevent>
                    <div class="row">
                        <div class="col-md-12">
                            <fg-input
                                type="text"
                                :label="$t('user.name')"
                                :placeholder="$t('user.name')"
                                v-model="form.name"
                            ></fg-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <fg-input
                                type="email"
                                :label="$t('user.email')"
                                :placeholder="$t('user.email')"
                                v-model="form.email"
                            ></fg-input>
                        </div>
                    </div>
                    <div class="row" v-if="isAdmin">
                        <div class="col-md-12">
                            <label class="typo__label">{{$t('user.asf')}}</label>
                            <multiselect
                                v-model="value"
                                :options="asfs"
                                :custom-label="asfLabel"
                                :placeholder="$t('user.text.selectone')"
                                label="name"
                                track-by="id"
                                @open="getAsfs"
                                @input="selectAsfs"
                            ></multiselect>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <label for="role">{{$t('user.role')}}</label>
                            <div class="form-check" v-if="isAdmin">
                                <input
                                    type="checkbox"
                                    class="form-check-input"
                                    v-model="form.role"
                                    value="admin"
                                    id="admin"
                                />
                                <label for="admin">{{$t('user.admin')}}</label>
                            </div>
                            <div class="form-check" v-if="showIfRoleIs('admin-rede')">
                                <input
                                    type="checkbox"
                                    class="form-check-input"
                                    v-model="form.role"
                                    value="admin-rede"
                                    id="admin-rede"
                                />
                                <label for="admin-rede">{{$t('user.redeadmin')}}</label>
                            </div>
                            <div class="form-check">
                                <input
                                    type="checkbox"
                                    class="form-check-input"
                                    v-model="form.role"
                                    value="asf-admin"
                                    id="asf-admin"
                                />
                                <label for="asf-admin">{{$t('user.asfadmin')}}</label>
                            </div>
                            <div class="form-check">
                                <input
                                    type="checkbox"
                                    class="form-check-input"
                                    v-model="form.role"
                                    value="asf-frontdesk"
                                    id="asf-frontdesk"
                                />
                                <label for="asf-frontdesk">{{$t('user.asffrontdesk')}}</label>
                            </div>
                            <div class="form-check">
                                <input
                                    type="checkbox"
                                    class="form-check-input"
                                    v-model="form.role"
                                    value="asf-technician"
                                    id="asf-technician"
                                />
                                <label for="asf-technician">{{$t('user.asftechnician')}}</label>
                            </div>
                        </div>
                    </div>
                    <br />
                    <div class="text-left">
                        <p-button type="primary" @click.native.prevent="saveUser">{{$t('user.button.save')}}</p-button>
                    </div>
                    <div class="clearfix"></div>
                </form>
            </div>
        </div>
    </card>
</template>
<script>
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect
  },
  data() {
    return {
      value: null,
      form: {
        name: "",
        email: "",
        asf: this.$store.getters["auth/getCurrentAsf"],
        role: []
      }
    };
  },
  computed: {
    ...mapState("users", {
      user: "user"
    }),
    ...mapState("asfs", {
      asfs: "all"
    }),
    isAdmin() {
      //console.log(this.$store.getters["auth/getIsAdmin"])
      return this.$store.getters["auth/getIsAdmin"];
    }
  },
  methods: {
     showIfRoleIs(role) {
      return this.$store.getters["auth/isInRoles"](role);
    },
    asfLabel({ name, vat }) {
      return `${name} — ${vat}`;
    },
    getAsfs() {
      this.$store.dispatch("asfs/getAllAsfs");
    },
    selectAsfs(option) {
      this.form.asf = option.id;
    },
    saveUser() {
      this.$store.commit("users/setUser", this.form);
      this.$store
        .dispatch("users/addUser", this.form)
        .then(response => {
          this.$router.push({ name: "users" });
          this.$notify({
            type: "success",
            horizontalAlign: "center",
            message: this.$t('user.message.successadd')
          });
        })
        .catch(error => {
          let msg = "";
          if (error.response.data) {
            msg = error.response.data.errors[0].detail;
          } else {
            msg = error.response.message;
          }
          this.$router.push({ name: "users" });
          this.$notify({
            type: "danger",
            horizontalAlign: "center",
            message: msg
          });
        });
    }
  }
};
</script>
<style>
</style>
